<template>
    <div class="wrapper">
        <div class="container">
            <div class="row no-gutters height-self-center">
                <div class="col-sm-12 text-center align-self-center">
                <div class="iq-error position-relative">
                        <img :src="notpage" class="img-fluid iq-error-img" alt="">
                        <h2 class="mb-0 mt-4">Oops! This Page is Not Found.</h2>
                        <p>The requested page dose not exist.</p>
                        <router-link to="/" class="btn btn-primary d-inline-flex align-items-center mt-3" exact>
                            <i class="ri-home-4-line"></i>Back to Home
                        </router-link>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import notpage from '@/assets/images/404.png'
</script>
<script>
import $ from "jquery";
    export default {
        name: 'HomePage',
        async mounted() {
            this.$store.state.pageTitle = ''
            this.$store.state.isLogin = 1
            $('body').removeClass('sidebar-main');
            if (this.$store.state.isActiveToken != '1') {
                // console.log(this.currentDate);
            } else {
                // await this.loadDashboardCnt();
            }
        },
    }
</script>
